import { polishLocale } from './pl';
import type { PluralRuleFunction } from '../plural-rules.types';

/**
 * Registry of locales requiring custom plural rules.
 * Unlisted locales use vue-i18n's default rule.
 *
 * To add a locale: create file → export LocaleDefinition → add to allLocales.
 */
const allLocales = [polishLocale];

export const pluralRulesMap: Record<string, PluralRuleFunction> = {};

for (const locale of allLocales) {
  for (const code of locale.locales) {
    pluralRulesMap[code] = locale.rule;
  }
}
